import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  type ChartOptions,
  type ChartDataset,
} from "chart.js";
import { Bar } from "react-chartjs-2";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

export default function BarsVertical({
  labels,
  datasets,
}: {
  labels: string[];
  datasets: ChartDataset<"bar", number[]>[];
}) {
  const chartOptions: ChartOptions<"bar"> = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          usePointStyle: true,
          padding: 15,
          pointStyle: "circle",
        },
      },
    },
  };

  return <Bar options={chartOptions} data={{ labels, datasets }} />;
}
